<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="$parent.closeTopUpModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="$parent.closeTopUpModal" src="./../images/close.svg" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">{{ $t(`Top up`) }}</div>
                <label>
                  <div class="desc">{{ $t(`Enter amount:`) }}</div>
                  <div class="input-container">
                    <input type="text" @input="allowOnlyNumbers" v-model="amount" />
                    <span class="currency-label">{{ currencyLabel }}</span>
                  </div>
                </label>
                <div class="exchange-rate">
                  <span>1</span>
                  <img src="../images/coin.svg" class="currency-icon" alt="coin"/>
                  <span>= {{ formattedCurrencyValue }} {{ currencyLabel }}</span>
                </div>
                <button 
                  :disabled="$parent.minOrderAmount && $parent.minOrderAmount > amount" 
                  @click="toCheckout" 
                  class="button"
                >Next</button>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopUpModal",
  props: ['currency', 'currencyCode', 'currencyValue'],
  components: {},
  data: function () {
    return {
      amount: 5
    };
  },
  computed: {
    formattedCurrencyValue() {
      const value = this.currencyValue;
      const numericValue = Number(value);

      if (!Number.isNaN(numericValue) && numericValue > 0) {
        return numericValue.toFixed(4);
      }

      return value || '1';
    },
    currencyLabel() {
      if (this.currencyCode) {
        return this.currencyCode;
      }

      if (this.currency) {
        return this.currency;
      }

      return '';
    }
  },
  mounted() {},
  methods: {
    allowOnlyNumbers(){
      this.amount = this.amount.replace(/[^0-9.,]/g, '');
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    },
    toCheckout() {
      this.$emit('setTopUpAmount', this.amount);
    },
  },
};
</script>
<style scoped>
.currency-label {
  position: absolute;
  right: 18px;
  color: white;
}
</style>